/**
 * Defines the authentication flow with keycloak-js
 *
 * see https://www.keycloak.org/docs/latest/securing_apps/#_javascript_adapter
 */
export enum SessionVerificationTypeEnum {
  LoginRequired = 'login-required',
  SilentCheckSso = 'check-sso'
}
